module.exports = __webpack_public_path__ + "img/02.486aaf09.jpg";